import React, { useState, useEffect } from "react";

export default function MealForm({ onAdd, editingMeal, onUpdate }) {
  const [name, setName] = useState("");
  const [calories, setCalories] = useState("");
  const [carbs, setCarbs] = useState("");
  const [protein, setProtein] = useState("");
  const [fats, setFats] = useState("");
  const [fiber, setFiber] = useState("");

  useEffect(() => {
    if (editingMeal) {
      setName(editingMeal.name || "");
      setCalories(editingMeal.calories || "");
      setCarbs(editingMeal.carbs || "");
      setProtein(editingMeal.protein || "");
      setFats(editingMeal.fats || "");
      setFiber(editingMeal.fiber || "");
    } else {
      setName("");
      setCalories("");
      setCarbs("");
      setProtein("");
      setFats("");
      setFiber("");
    }
  }, [editingMeal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const mealData = {
      name: name,
      calories: parseInt(calories) || 0,
      protein: parseInt(protein) || 0,
      carbs: parseInt(carbs) || 0,
      fats: parseInt(fats) || 0,
      fiber: parseInt(fiber) || 0,
    };

    if (editingMeal) {
      onUpdate(editingMeal.id, mealData);
    } else {
      onAdd(mealData);
    }

    setName("");
    setCalories("");
    setCarbs("");
    setProtein("");
    setFats("");
    setFiber("");
  };

  return (
    <form onSubmit={handleSubmit} className="meal-form">
      <input type="text" placeholder="Meal Name" value={name} onChange={(e) => setName(e.target.value)} required />
      <input type="number" min="0" placeholder="Calories" value={calories} onChange={(e) => setCalories(e.target.value)} required />
      <input type="number" min="0" placeholder="Carbs (g)" value={carbs} onChange={(e) => setCarbs(e.target.value)} required />
      <input type="number" min="0" placeholder="Protein (g)" value={protein} onChange={(e) => setProtein(e.target.value)} required />
      <input type="number" min="0" placeholder="Fats (g)" value={fats} onChange={(e) => setFats(e.target.value)} required />
      <input type="number" min="0" placeholder="Fiber (g)" value={fiber} onChange={(e) => setFiber(e.target.value)} required />
      
      <button type="submit" className="btn-submit">
        {editingMeal ? "Save Update" : "Add Meal"}
      </button>
    </form>
  );
}